<template>
    <div class="headerBox">
        <div class="header">
            <div class="headerLogo">
                <img src="../../assets/images/logo.png" alt="">
            </div>

            <div class="list" id="vocHeader"></div>

            <div class="other">
                <div class="login-text">
                    <a-dropdown>
                        <div class="login-out-wrap ant-dropdown-link">
                            <span class="login">欢迎您，{{userName}}</span>
                        </div>
                        <a-menu slot="overlay">

                            <a-menu-item key="1">
                                <span class="login-info-btn" @click="loginOut">退出登录</span>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </div>
        </div>
        <tags-view></tags-view>
    </div>
</template>

<script>
    import UrlApi from "../../utils/UrlApi"

    import Cookie from "js-cookie";
    import tagsView from "../TagsView/index"


    export default {
        name: "newHeader",
        inject: ['reload'],
        components: {tagsView},
        data() {
            return {

                routerList: [],
                cityList: [],
                roleList: {},
                cityCode: '',
                activeIndex: '',
            }
        },
        created() {
            this.getUserInfo()
        },
        computed: {
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
            userName: {
                get() {
                    return this.$store.state.userName
                }
            },
            VOCTagsList: {
                get() {
                    return this.$store.state.VOCTagsList
                },
                set(val) {
                    this.$store.commit("updateVOCTagsList", val);
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next()
        },
        methods: {

            // 登出
            loginOut() {
                let url = UrlApi.loginOut;
                let token = this.$store.getters.getToken;
                let userId = this.$store.getters.getUserId;
                this.$http.get(url, {
                    params: {
                        userId: userId
                    },
                    headers: {
                        'Authorization': token,
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then((res) => {
                    let message = res.data.message;
                    if (res.data.success) {
                        this.$message.success(message);
                        Cookie.remove("BSG-userInfo");

                        localStorage.removeItem('token')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userType')
                        this.$router.replace({
                            name: 'login'
                        })
                        return;
                    }
                    this.$message.error(message);
                })
            },

            //  获取用户信息
            getUserInfo() {
                let url = UrlApi.GetUserInfo
                this.$http.get(url, {
                    params: {}
                }).then(res => {
                    // console.log(res)
                    // window.localStorage.getItem('gpsState')
                    // this.userType = res.data.data.type
                    this.userType = res.data.data.userInfo.roleId
                    this.userId = res.data.data.userId
                    this.cityCode = res.data.data.cityCode
                    this.gpsState = {
                        area: res.data.data.area,
                        city: res.data.data.city,
                        cityCode: res.data.data.cityCode
                    }

                })
            },

        }
    }
</script>

<style scoped lang="less">
    .headerBox {
        display: block;
    }

    .header {
        display: flex;
        background-color: #063066;
        padding: 10px 0;
        align-items: center;
        color: #fff;
        width: 100%;
        .headerLogo {
            margin: 0 20px;
            img {
                width: 40px;
                height: 40px;
            }
        }
        .list {
            flex: 1;
            display: flex;
            .item {
                position: relative;
                margin: 0 10px;
                min-width: 80px;
                cursor: pointer;
                .itemValue {
                    /*border: 1px solid #fff;*/
                    padding: 8px;
                }
                .itemList {

                    width: 180%;
                    z-index: 999;
                    color: #fff;
                    position: absolute;
                    top: 26px;
                    background-color: #000928;
                    opacity: 0.8;
                    padding: 10px;
                    border-radius: 10px;
                    transition: all .5s;
                    display: none;
                    .itemItem {
                        /*border-bottom: 1px solid #c8c8c8;*/
                        padding: 8px;
                        cursor: pointer;
                        border-radius: 10px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        &:last-child {
                            border-bottom: none;
                        }
                    }
                    .itemItem:hover {
                        background-color: rgba(155, 146, 166, 0.8);
                    }
                }
            }
            .item:hover {
                .itemList {
                    display: block;
                }
            }
        }
        .other {
            margin: 0 20px;
        }
    }
</style>
